module.exports = __webpack_public_path__ + "img/whole-team.43e8fff6.png";